/* Sales page (sp-*) behaviour. Built by Glaze for Equinutritive.
   No dependencies. Safe to load with defer on any page. */
(function () {
  'use strict';

  /* ---------- Dispatch countdown (always UK time) ---------- */
  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var DAY_INDEX = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

  function londonNow() {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/London', weekday: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
      }).formatToParts(new Date());
      var o = {};
      parts.forEach(function (p) { o[p.type] = p.value; });
      return { day: DAY_INDEX[o.weekday], secs: (+o.hour) * 3600 + (+o.minute) * 60 + (+o.second) };
    } catch (e) {
      var d = new Date();
      return { day: d.getDay(), secs: d.getHours() * 3600 + d.getMinutes() * 60 + d.getSeconds() };
    }
  }

  function pad(n) { return String(n).padStart(2, '0'); }

  function dispatchState(cutoffHour) {
    var now = londonNow();
    var cutoff = cutoffHour * 3600;
    var isWorkday = now.day >= 1 && now.day <= 5;
    var remaining, nextDay, sameDay;
    if (isWorkday && now.secs < cutoff) {
      sameDay = true;
      remaining = cutoff - now.secs;
    } else {
      sameDay = false;
      var add = 0, d = now.day;
      do { add++; d = (d + 1) % 7; } while (d === 0 || d === 6);
      nextDay = d;
      remaining = add * 86400 - now.secs + cutoff;
    }
    var h = Math.floor(remaining / 3600), m = Math.floor((remaining % 3600) / 60), s = remaining % 60;
    return { sameDay: sameDay, nextDay: nextDay, h: h, m: m, clock: pad(h) + ':' + pad(m) + ':' + pad(s) };
  }

  function fill(tpl, st, cutoffLabel) {
    return String(tpl || '')
      .replace(/\[hours\]/g, st.h)
      .replace(/\[minutes\]/g, st.m)
      .replace(/\[day\]/g, st.nextDay != null ? DAYS[st.nextDay] : '')
      .replace(/\[cutoff\]/g, cutoffLabel);
  }

  function tickDispatch() {
    document.querySelectorAll('[data-sp-dispatch]').forEach(function (el) {
      var cutoff = parseInt(el.getAttribute('data-cutoff') || '13', 10);
      var label = el.getAttribute('data-cutoff-label') || '1pm';
      var st = dispatchState(cutoff);
      var key = st.sameDay ? 'today' : 'later';
      el.querySelectorAll('[data-sp-dispatch-head]').forEach(function (n) { n.textContent = fill(el.getAttribute('data-head-' + key), st, label); });
      el.querySelectorAll('[data-sp-dispatch-sub]').forEach(function (n) { n.textContent = fill(el.getAttribute('data-sub-' + key), st, label); });
      el.querySelectorAll('[data-sp-dispatch-clock]').forEach(function (n) { n.textContent = st.clock; });
    });
  }

  /* ---------- Sticky bar ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-sp-sticky]');
    if (!bar) return;
    var threshold = parseInt(bar.getAttribute('data-threshold') || '700', 10);
    var offer = document.getElementById('offer');
    var ticking = false;
    function update() {
      ticking = false;
      var inOffer = false;
      if (offer) {
        var r = offer.getBoundingClientRect();
        inOffer = r.top < window.innerHeight && r.bottom > 0;
      }
      var show = window.scrollY > threshold && !inOffer;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.querySelectorAll('a, button').forEach(function (n) { n.tabIndex = show ? 0 : -1; });
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Customer videos: play muted when in view ---------- */
  function initVideos() {
    var vids = document.querySelectorAll('.sp-video video');
    if (!vids.length) return;
    vids.forEach(function (v) { v.muted = true; v.loop = true; v.playsInline = true; v.setAttribute('playsinline', ''); });
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { var p = e.target.play(); if (p && p.catch) p.catch(function () {}); }
        else e.target.pause();
      });
    }, { threshold: 0.35 });
    vids.forEach(function (v) { io.observe(v); });
  }

  /* ---------- Offer: gallery, plan picker, add-on, add to cart ---------- */
  function initOffer(root) {
    var main = root.querySelector('.sp-main-img');
    root.querySelectorAll('[data-sp-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!main) return;
        main.src = btn.getAttribute('data-full');
        main.removeAttribute('srcset');
        main.alt = btn.getAttribute('data-alt') || main.alt;
        root.querySelectorAll('[data-sp-thumb]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
        btn.setAttribute('aria-current', 'true');
      });
    });

    var form = root.querySelector('[data-sp-offer-form]');
    if (!form) return;
    var btn = form.querySelector('[data-sp-atc]');
    var label = form.querySelector('[data-sp-atc-label]');
    var errorEl = form.querySelector('[data-sp-atc-error]');
    var addon = form.querySelector('[data-sp-addon]');
    var redirect = form.getAttribute('data-redirect') || '/cart';
    var btnText = form.getAttribute('data-button-text') || 'Add to cart - [price]';

    var idInput = form.querySelector('[data-sp-variant-id]');
    function selected() { return form.querySelector('input[name="sp-variant"]:checked') || form.querySelector('input[name="id"]:checked'); }

    function refresh() {
      form.querySelectorAll('.sp-plan').forEach(function (p) {
        var i = p.querySelector('input'); p.classList.toggle('is-checked', !!(i && i.checked));
      });
      var addonOn = !!(addon && addon.checked);
      if (addon) addon.closest('.sp-addon').classList.toggle('is-checked', addonOn);
      var sel = selected();
      if (sel && idInput && idInput.value !== sel.value) {
        idInput.value = sel.value;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (!sel || !label) return;
      var price = addonOn ? sel.getAttribute('data-total-addon') : sel.getAttribute('data-total');
      label.textContent = btnText.replace('[price]', price || '');
    }

    form.addEventListener('change', refresh);
    refresh();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var sel = selected();
      if (!sel) return;
      var items = [{ id: parseInt(sel.value, 10), quantity: 1 }];
      if (addon && addon.checked && addon.value) items.push({ id: parseInt(addon.value, 10), quantity: 1 });
      if (errorEl) errorEl.classList.remove('is-visible');
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(shopRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (r) {
          if (!r.ok) throw new Error((r.data && (r.data.description || r.data.message)) || 'Something went wrong. Please try again.');
          document.dispatchEvent(new CustomEvent('sp:added-to-cart', { detail: { items: items } }));
          if (redirect !== 'drawer') { window.location.href = redirect; return; }
          /* Stay on the page: the store's cart drawer app opens by itself.
             Nudge Rebuy Smart Cart in case it didn't pick the add up. */
          try {
            var R = window.Rebuy;
            if (R && R.Cart && typeof R.Cart.fetchCart === 'function') R.Cart.fetchCart();
            if (R && R.SmartCart && typeof R.SmartCart.show === 'function') R.SmartCart.show();
          } catch (e) {}
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          if (label) {
            label.textContent = form.getAttribute('data-added-text') || 'Added to cart';
            setTimeout(refresh, 2500);
          }
        })
        .catch(function (err) {
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          if (errorEl) { errorEl.textContent = err.message; errorEl.classList.add('is-visible'); }
        });
    });
  }

  function init() {
    document.querySelectorAll('[data-sp-offer]').forEach(initOffer);
    initSticky();
    initVideos();
    if (document.querySelector('[data-sp-dispatch]')) {
      tickDispatch();
      setInterval(tickDispatch, 1000);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Re-initialise when sections are edited in the theme editor */
  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    t.querySelectorAll('[data-sp-offer]').forEach(initOffer);
    if (t.querySelector('[data-sp-sticky]')) initSticky();
    if (t.querySelector('.sp-video video')) initVideos();
    tickDispatch();
  });
})();
